import styled from "styled-components";

export const TippingHistoryRecordStartSectionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 120px;
  height: 150px;
  margin-right: 10px;
  margin-bottom: 5px;
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    margin-bottom: 0;
  }

  & > img {
    width: auto;
    max-height: 100%;
  }
    
`